import React, { Fragment } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import Header from '../../../components/header';
import Head from '../../../components/head';
import Footer from '../../../components/footer';
import ListaLicitacoesExpo24 from '../../../components/licitacao/listar/expomacuco';


function ListaLicitacoesExpo24Screen() {
    return (
        <Fragment>
            <Head titulo="Licitações realizadas para a Expo Macuco 2024" />
            <Header />
            <Container>
                <ListaLicitacoesExpo24 />
            </Container>
            <Footer />
        </Fragment>
    );
}

export default ListaLicitacoesExpo24Screen;